// @ts-nocheck
// Greif UI Kit = line-language
import React from "react";

const LanguageLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m-7.317 9.818a7.37 7.37 0 0 0 5.459 6.308 13.33 13.33 0 0 1-2.19-6.308zm11.364 0a13.3 13.3 0 0 1-2.19 6.308 7.37 7.37 0 0 0 5.46-6.308zm-6.453 0A11.7 11.7 0 0 0 12 18.908a11.7 11.7 0 0 0 2.406-6.09zm4.263-7.945a13.3 13.3 0 0 1 2.19 6.309h3.27a7.37 7.37 0 0 0-5.46-6.31M12 5.09a11.7 11.7 0 0 0-2.406 6.092h4.812A11.7 11.7 0 0 0 12 5.09m-1.858-.217a7.37 7.37 0 0 0-5.459 6.309h3.27c.183-2.262.94-4.431 2.189-6.31"
            />
        </svg>
    );
};

export default React.memo(LanguageLine);
